import React from 'react';
import "primeicons/primeicons.css";
import 'primereact/resources/primereact.min.css';
import { FormSubSections, FormSectionElements, ProgramContainer } from '../entities/formTemplateDataType';
import Utils from '../utilities/Utils';
import XMLParser from '../utilities/XMLParser';
import { ElementListComponent } from './ElementListComponent';
import axios from 'axios';
import URLUtils from '../utilities/URLUtils';
import { FileUpload } from 'primereact/fileupload';
import '../../public/assets/css/App.css';
import { Button, Column, DataTable, InputText } from 'primereact';
import classNames from 'classnames';
import { User } from '../entities/User';
import * as XLSX from 'xlsx';
import { InformationalAlertComponent } from './odsCalloutBox/InformationalAlertComponent';
import { WarningAlertComponent } from './odsCalloutBox/WarningAlertComponent';
import { SuccessAlertComponent } from './odsCalloutBox/SuccessAlertComponent';
import { HintExpansionComponent } from './odsCalloutBox/HintExpansionComponent';
import { ErrorAlertComponent } from './odsCalloutBox/ErrorAlertComponent';
import { GeneralCalloutComponent } from './odsCalloutBox/GeneralCalloutComponent';
import { DateComponent } from './subComponent/DateComponent';
import { OdsDateComponent } from './subComponent/OdsDateComponent';
import { PostalCodeComponent } from './subComponent/PostalCodeComponent';
import { EmailComponent } from './subComponent/EmailComponent';
import { TextComponent } from './subComponent/TextComponent';
import { MultiTextComponent } from './subComponent/MultiTextComponent';
import { AutoCompleteComponent } from './subComponent/AutoCompleteComponent';
import { DropdownComponent } from './subComponent/DropdownComponent';
import { CheckboxComponent } from './subComponent/CheckboxComponent';
import { DriverLicenseComponent } from './subComponent/DriverLicenseComponent';
import { GroupDropdownComponent } from './subComponent/GroupDropdownComponent';
import { NumberComponent } from './subComponent/NumberComponent';
import { PhoneComponent } from './subComponent/PhoneComponent';
import { CurrencyComponent } from './subComponent/CurrencyComponent';
import { LicensePlateComponent } from './subComponent/LicensePlateComponent';
import { HealthCardComponent } from './subComponent/HealthCardComponent';
import { ButtonComponent } from './subComponent/ButtonComponent';
import { BusinessNumberComponent } from './subComponent/BusinessNumberComponent';
import { DateTimeComponent } from './subComponent/DateTimeComponent';
import { GoogleLookUpAddressComponent } from './subComponent/GoogleLookUpAddressComponent';
import { MultipleCheckboxComponent } from './subComponent/MultipleCheckboxComponent';
import { CheckboxWithTextboxComponent } from './subComponent/CheckboxWithTextboxComponent';
import { RadioButtonComponent } from './subComponent/RadioButtonComponent';
import { SelectWithRichTextComponent } from './subComponent/SelectWithRichTextComponent';
import { RichTextComponent } from './subComponent/RichTextComponent';
import { AddressComponent } from './subComponent/AddressComponent';
import { RowComponent } from './subComponent/RowComponent';
import { EmailButtonComponent } from './subComponent/EmailButtonComponent';
import { TableComponent } from './subComponent/TableComponent';
import { HiddenFieldComponent } from './subComponent/HiddenFieldComponent';
import { CheckboxWithInlineTextboxComponent } from './subComponent/CheckboxWithInlineTextboxComponent';
import { getRootComponent } from '../utilities/ElementUtils';
import AccordionsComponent from '../commonComponent/AccordionsComponent';
import FileUploadComponent from './subComponent/FileUploadComponent';
import FeedbackComponent from './subComponent/FeedbackComponent';
import { TechErrorComponent } from './subComponent/TechErrorComponent';
import StartRatingAccessibilityComponent from './subComponent/StarRatingAccessibilityComponent';
import TransactionIdComponent from './subComponent/TransactionIdComponent';
import { RepeatButtonComponent } from './subComponent/RepeatButtonComponent';
import { EmailConfirmationComponent } from './subComponent/EmailConfirmationComponent';
import { PublicSecureButtonComponent } from './subComponent/PublicSecureButtonComponent';
import { DataTableComponent } from './subComponent/DataTableComponent';
import { TableMenuComponent } from './subComponent/TableMenuComponent';
import { CustomErrorAlertsComponent } from './subComponent/CustomErrorAlertsComponent';
import { SubmitButtonComponent } from './subComponent/SubmitButtonComponent';
import SummaryListComponent from './subComponent/SummaryListComponent';
import { CMAQuestionComponent } from './subComponent/cma/CMAQuestionComponent';
import { parseJson, stringifyJson } from '../utilities/JsonUtils';


interface Props {
  isEng: boolean;
  field: FormSectionElements;
  editable: boolean;
  roleBasedEditable?: boolean;
  user?: User;
  callbackElement: (programContainer: ProgramContainer)=> void;
  topEntity?;
  roleBased?: boolean;
  usedForFilter?: boolean;
  ownerEditableOnly?: boolean;
  UseAsterisks?,
  returnIndex?:number;
  callbackStepIndex?: (index: number, returnIndex?: number) => void;
  callbackValidate?: (errors:any)=>void
}

interface State {
  // activeObject: FormSectionElements;
  // editable: boolean;
  // callbackElement;
  // user: User;
  // topEntity;
 // suggestions;
  touched: boolean
  attContent: any
}

var fieldIds = [];

export class ElementComponent extends React.Component<Props, State> {
  subSection: FormSubSections;
  attachmentContent = [];
  worksheetNames = [];
  fileUploaded = false;
  toast;
  HtmlToReactParser = require('html-to-react').Parser;

  readonly TOTAL_COLUMN_VALUE = "Totals:"

  constructor(props: Props) {
    super(props);
   
    // this.props.field.DisplayedInScreen = true;
    this.state = {
      //   activeObject: this.props.field,
      //   editable: this.props.editable,
      //   callbackElement: this.props.callbackElement,
      //   user: this.props.user,
      //   topEntity: this.props.topEntity,
      touched: false,
      attContent: []
    };

 
  }


  onTextEditChange = (e) => {
    let elem = e.originalEvent ? e.originalEvent.target : e.target;
    let val = elem.value;
    this.props.field.Valid = Utils.isNotNullOrEmpty(val);
    this.props.field.Value = val;
    // this.setState({ activeObject: this.props.field });
    this.props.callbackElement(this.props.field.parent.parent.parent);
  }


  render() {
    return this.generateFieldControl(this.props.field);
  }

  valueLength(value) {
    if (typeof value == 'string') {
      return value.length;
    }
    return 0;
  }

  generateFieldControl = (field: FormSectionElements) => {
   
    var controlArray = [];
 
    var title = this.props.isEng ?field.ENUTitle: field.FRATitle;
    if (title === '.') {
      title = '';
    }

    var editable = field.Editable === 'Y' && this.props.editable;
    let parentSub = field.parent as FormSubSections;

    //let subEditable = parentSub.ListOfFormSectionElements?.filter(p => p.Editable === 'Y').length > 0 && this.props.editable;
    var requiredField = field.Optional !== 'Y';
    let labelControlArray = [];
   
    const htmlToReactParser = new this.HtmlToReactParser();
    const reactElement = field.MessageBody != null ? htmlToReactParser.parse(this.props.isEng? field.MessageBody: field.MessageBodyFRA) : null;
    let hintHtml=this.props.isEng? field.Hint:field.HintFR;
    let hint;
    if (field.Hint||field.HintFR) {
      hint = htmlToReactParser.parse(hintHtml);
    }

    // controlArray.push(<div style={{ alignContent: 'center', alignItems: 'center', width:'100%' }}>{reactElement}</div>);
    const requireLabel=this.props.isEng? "(required)":"(obligatoire)";
    if(field.richTextChecked && Utils.isNotNullOrEmpty(title) ){
      title=htmlToReactParser.parse(title);
    }

    if (requiredField === true) {
      labelControlArray.push(
        <div key={'fdLbl_' + field.Id} className='ontario-margin-top-24-!'>
          {title &&(
            // <label aria-label={title + ' required'} htmlFor={field.LoadBindName} className="ontario-label" >
            <label htmlFor={field.LoadBindName} className="ontario-label" >
              {title}<span className="ontario-label__flag">{this.props.UseAsterisks=="Y"?<span style={{color:'red'}}>*</span>:<span className='ontario-label__flag'>{requireLabel}</span>}
              </span>
              {field.TooltipENU && (<i role='tooltip' title={field.TooltipENU} className="pi pi-info-circle"></i>)} 
            </label>
          )}

          {hint ? <p className="ontario-hint">{hint}</p> : null}
        </div>);     
    } else {
      labelControlArray.push(
        <div key={'fdLbl_' + field.Id} className='ontario-margin-top-24-!'>
          <label aria-label={title} htmlFor={field.LoadBindName}  className="ontario-label" >{title} <span className="ontario-label__flag">{!this.props.field.ReadOnly &&(this.props.isEng ?"(optional)": "(facultatif)") }</span>
            {field.enuToolTip ? <i title={field.TooltipENU} className="pi pi-info-circle"></i> : null}
          </label>
          {hint ? <p className="ontario-hint">{hint}</p> : null}
        </div>);
    }
    // }
    let displayfield: boolean = true;

    const setFieldValue = (value: any) => {
      field.Value = value;
      const programContainer = getRootComponent(field);
      this.props.callbackElement(programContainer);
    };
 
    switch (field.Datatype) {
      case 'RadioButton':
        controlArray.push(
          <RadioButtonComponent key={"RadioButtonComponent_" + field.parent.Id + "_" + field.Id}
            field={this.props.field}
            editable={editable} title={title} 
            labelControlArray={labelControlArray}
            requiredField={requiredField} isEng={this.props.isEng}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}
          />
        );
        break;
      case 'Row':
        controlArray.push(
          <RowComponent
            key={"RowComponent_" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField} isEng={this.props.isEng}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}
            callbackStepIndex={(index)=>this.props.callbackStepIndex(index)} >
          </RowComponent>
        );
        break;

      case 'CheckGroup':
        controlArray.push(<MultipleCheckboxComponent key={"MultipleCheckboxComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField} isEng={this.props.isEng}
        callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>

        </MultipleCheckboxComponent>);
        break;
      case 'Date':
        controlArray.push(
          <DateComponent key={"DateComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField} isEng={this.props.isEng}
          callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>

          </DateComponent>);

        break;
      case 'DateTime':
          controlArray.push(
            <DateTimeComponent key={"DateTimeComponent" + field.Id}  field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </DateTimeComponent>);
  
          break;
      case 'ODSDate':
        controlArray.push(
          <OdsDateComponent key={"OdsDateComponent" + field.Id}  
            field={this.props.field} editable={editable} title={title} 
            labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng} hint={hint} useAsterisks={this.props.UseAsterisks}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </OdsDateComponent>);

        break;
      case 'PostalCode':
           controlArray.push(
            <PostalCodeComponent key={"PostalCodeComponent" + field.Id}  field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng}
              callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </PostalCodeComponent>
           );
        break;
      case 'Currency':
        controlArray.push(
          <CurrencyComponent key={"CurrencyComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </CurrencyComponent>
         );
        break;
      case 'Percentage':
        if (editable) {
          controlArray.push(
            <div key={'fd_' + field.Id}  >
              <div key={'fdLbl_div_' + field.Id} >
                {labelControlArray}
              </div>
              <div key={'fdIpt_div_' + field.Id} style={{ display: 'flex', marginBottom: '30px', verticalAlign: 'middle' }}>
                <span className="p-input-icon-left">
                  <i className="pi pi-percentage" />
                  <InputText className="ontario-input" style={{ width: "90%", textAlign: 'right' }} keyfilter="num" id={'fdIpt_' + field.Id} key={'fdIpt_' + field.Id} required={requiredField} value={field.Value} readOnly={field.ReadOnly} onChange={this.onTextEditChange} />
                </span>
              </div>
            </div>);
        } else {
          controlArray.push(
            <div className={classNames('pdf-two-column', { 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >
              <div>{title}</div>
              <div> {field.Value}</div>
            </div>
          );
        }
        break;
      case 'PhoneNumber':
        controlArray.push(
          <PhoneComponent key={"PhoneComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}   callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </PhoneComponent>
        );
        break;
      case 'BusinessNumber':
          controlArray.push(
            <BusinessNumberComponent key={"BusinessNumberComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng}
              callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </BusinessNumberComponent>
          )
          break;   
        case 'Email':
          controlArray.push(
            <EmailComponent  key={"EmailComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng}
                callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </EmailComponent>
          );
          break;
        case 'EmailConfirmation':
            controlArray.push(
              <EmailConfirmationComponent  key={"EmailConfirmationComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
              isEng={this.props.isEng}
                  callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
              </EmailConfirmationComponent>
            );
        break;
        case 'EmailButton':
          controlArray.push(
            <EmailButtonComponent  key={"EmailComponent" + field.Id} field={this.props.field} editable={editable} title={title} 
                labelControlArray={labelControlArray} requiredField={requiredField}
                isEng={this.props.isEng}
                callback={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </EmailButtonComponent>
          );
        break;
      case 'Number':
        controlArray.push(
          <NumberComponent key={"NumberComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng} 
             callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </NumberComponent>
        )
       
    
        break;
      case "Text":
        controlArray.push(
          <TextComponent key={"TextComponent_" + field.parent.Id + "_" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}
             callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </TextComponent>
        );
        break;
      case 'MultiText':
        controlArray.push(
          <MultiTextComponent key={"MultiTextComponent" + field.Id}  field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}
             callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </MultiTextComponent>
        );

        break;
      case 'Dropdown':
        controlArray.push(
          <DropdownComponent key={"DropdownComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng} usedForFilter={this.props.usedForFilter}
             callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </DropdownComponent>
        );
        break;
      case 'GroupDropdown':
        controlArray.push(
          <GroupDropdownComponent key={"GroupDropdownComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng} usedForFilter={this.props.usedForFilter}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </GroupDropdownComponent>
        )
        break;
    
      case 'CheckboxGroup':
      case 'Checkbox':
        controlArray.push(
          <CheckboxComponent key={"CheckboxComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng} usedForFilter={this.props.usedForFilter} hint={hint}
             callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </CheckboxComponent>
        );
        break;

      case 'CheckboxWithTextbox':
        controlArray.push(
          <CheckboxWithTextboxComponent key={"CheckboxWithTextboxComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng} usedForFilter={this.props.usedForFilter} 
              callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </CheckboxWithTextboxComponent>
        );
        break;

      case 'CheckboxWithInlineTextbox':
        controlArray.push(
          <CheckboxWithInlineTextboxComponent key={"CheckboxWithInlineTextboxComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng} usedForFilter={this.props.usedForFilter} 
              callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
          </CheckboxWithInlineTextboxComponent>
        );
        break;

      case 'CMAQuestion':
        controlArray.push(
          <CMAQuestionComponent key={"CMAQuestionComponent" + field.Id}
            field={this.props.field}
            editable={editable} title={title} 
            labelControlArray={labelControlArray}
            requiredField={requiredField} isEng={this.props.isEng}
            callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}
          />
        );
        break;
      case 'SelectWithRichText':
          controlArray.push(
            <SelectWithRichTextComponent 
              key={"SelectWithRichTextComponent" + field.Id} 
              field={this.props.field} editable={editable} title={title} 
              labelControlArray={labelControlArray} 
              requiredField={requiredField}
              isEng={this.props.isEng}
              callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </SelectWithRichTextComponent>
          );
  
        break;
        case 'HTML':
        case 'Label':
          controlArray.push(
            <RichTextComponent 
              key={"RichTextComponent" + field.Id} field={this.props.field} 
              editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
              isEng={this.props.isEng}
              callbackStepIndex={(index, returnIndex)=>this.props.callbackStepIndex(index,returnIndex)}
              callbackElement={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
            </RichTextComponent>
          );
  
          break;
          case 'TechError':
            controlArray.push(
              <TechErrorComponent 
                key={"TechError_" + field.Id} 
                isEng={this.props.isEng}
                field={field}
                callback={(programContainer: ProgramContainer) => {this.props.callbackElement(programContainer)}}>
              </TechErrorComponent>
            );
    
            break;
      case 'Table':
       controlArray.push(
          <TableComponent 
            field={this.props.field} 
            editable={editable} 
            title={title} 
            labelControlArray={labelControlArray} 
            requiredField={requiredField}
            isEng={this.props.isEng}
            callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}>
          </TableComponent>
        )
        break;
        case 'SummaryList':
          controlArray.push(
             <SummaryListComponent 
               field={this.props.field} 
               isEng={this.props.isEng}
               callback={(programContainer) => {this.props.callbackElement(programContainer)}}
               callbackStepIndex={(index) => {this.props.callbackStepIndex(index)}}>
             </SummaryListComponent>
           )
           break;
      case 'DataTable':
        controlArray.push(
            <DataTableComponent isEng={this.props.isEng}
              field={this.props.field} 
              callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}>
            </DataTableComponent>
          )
          break;
      case 'TableMenu':
      controlArray.push(
          <TableMenuComponent 
            field={this.props.field} 
            isEng={this.props.isEng}
            callbackStepIndex={(index, returnIndex)=>this.props.callbackStepIndex(index,returnIndex)}
            callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}>
          </TableMenuComponent>
        )
        break;
      case 'AutoComplete':
        controlArray.push(
          <AutoCompleteComponent field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}
             callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}>
          </AutoCompleteComponent>
        )
        break;
      case 'Address':
        controlArray.push(
          <AddressComponent key={"AddressComponent" + field.Id}
            field={this.props.field} 
            editable={editable} title={title} 
            labelControlArray={labelControlArray} 
            requiredField={requiredField}
            isEng={this.props.isEng}  
            callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}>
          </AddressComponent>
        );
        break;
        case 'HiddenField':
          controlArray.push(
            <HiddenFieldComponent key={"HiddenField" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}  
            callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}>
          </HiddenFieldComponent>);
          break;
      case 'ConditionalLabel':
        if (this.props.field.FilterField != null) {
          let filterValue;
          let baseName;
          let bindName;
          let parts = this.props.field.FilterField.split('.');
          if (parts.length == 3) {
            baseName = parts[0] + '.' + parts[1];
            bindName = parts[2];
          }
          if (parts.length == 2) {
            baseName = parts[0];
            bindName = parts[1];
          }
          if (parts.length == 1) {
            baseName = '';
            bindName = parts[0];
          }
          let foundFilterField
          let foundFilterFields = XMLParser.extractFormSectionElement(baseName, bindName);
          if (foundFilterFields != null && foundFilterFields.length > 0) {
            foundFilterField = foundFilterFields.at(0);
          }
          if (foundFilterField != null) {
            filterValue = foundFilterField.Value;

            if (filterValue == null || filterValue != null && (this.props.field.FilterValue.indexOf(filterValue) == -1 && filterValue.indexOf(this.props.field.FilterValue) == -1)) {
              displayfield = false;
            }
          } else {
            displayfield = true;
          }

          if (this.props.field.FilterCompareMethod != null && this.props.field.FilterCompareMethod != '') {
            if (foundFilterField != null && foundFilterField.Value != null && foundFilterField.Datatype == 'Date' && this.props.field.FilterCompareMethod == 'lessthan') {
              let otherDate = new Date(foundFilterField.Value);
              let today = new Date();
              var diff = Math.abs(today.getTime() - otherDate.getTime());
              var diffDays = Math.ceil(diff / (1000 * 3600 * 24));

              displayfield = diffDays >= Number.parseInt(this.props.field.FilterValue);
            }
          }
          if (displayfield) {
            controlArray.push(
              <div key={'Label_' + field.Id} >
                {labelControlArray}
              </div>);
          }
        }
        break;
      case 'Excel Template':
        controlArray.push(
          this.extractHeadersAndDownloadFile(field)
        )

      case 'Excel':
        this.fileField = field;
        let excelData
        if (this.props.topEntity != null) {
          excelData = this.props.topEntity[this.fileField.LoadBindName];
        }

        if (excelData && excelData.length > 0) {
          controlArray.push(<div>
            <DataTable key={'file_' + field.Id} value={excelData} id={'table_' + + field.Id} dataKey="id" emptyMessage={null} style={{ width: '100%' }}>
              <Column field="attachmentFileName" header="File Name" />
              <Column body={this.actionTemplate} style={{ textAlign: 'center', width: '6em' }} />
            </DataTable>
          </div>);
        }

        if (editable) {
          controlArray.push(<div>
            {/* @ts-ignore */}
            <FileUpload name="attachment[]" customUpload={true} maxFileSize={5000000} onRemove={this.onExcelRemove} auto={true} uploadHandler={this.excelUploader} />
          </div>);
        }

        { this.displayExcelTable(field) }

        //this.setState({activeObject:field});

        if (field.subSectionList) {
          let subSectionLs = field.subSectionList;
          subSectionLs.forEach(subSection => {
            if (editable || this.props.roleBased) {

              controlArray.push(
                <div title={field.TooltipENU} style={{ width: '100%' }}>
                  {/* {labelControlArray} */}
                  <div key={'fd_' + field.Id} title={field.TooltipENU} style={{ width: '100%' }}>
                    <ElementListComponent
                      key={'sub_list' + field.Id} {...this.props}
                      activeSubSection={subSection}
                      topEntity={this.props.topEntity}
                      user={this.props.user}
                      usedByDesigner={false}
                      editable={this.props.roleBased ? this.props.roleBasedEditable : editable}
                      callback={() => { this.props.callbackElement(subSection.parent.parent); }} />
                  </div>
                </div>

              )
            } else {
              controlArray.push(
                <div style={{ textAlign: 'center' }}>
                  <div style={{ width: '100%' }}>{field.ENUTitle}</div>this.props.user
                  <div style={{ width: '100%' }}> <ElementListComponent key={'sub_' + field.Id} {...this.props} usedByDesigner={false} activeSubSection={subSection} topEntity={this.props.topEntity}
                    user={this.props.user} editable={false} callback={() => this.props.callbackElement(subSection.parent.parent)} /></div>
                </div>)
            }
          });
        }


        break;
      case 'File':
        this.fileField = field
        let allowedFileTypes = field.FileUpload?.AllowedForUploadFileTypeList?.join(", ") ?? '';

        if (editable) {
          controlArray.push(
            <FileUploadComponent
              field={field}
              lang={this.props.isEng? 'en' : 'fr'}
              title={this.props.isEng? 'Choose a file' : 'Choisissez un fichier'}
              setFieldValue={setFieldValue}
            />
          );
          // controlArray.push(
          //   <div>   
          //     <div>
          //       {/* @ts-ignore */}
          //       <Toast ref={(el) => this.toast = el} />
          //     </div>
          //     {/* @ts-ignore */}
          //     <FileUpload name="attachment[]" customUpload={true} auto={true} multiple={true}
          //       maxFileSize={Number(field.FileSize)}
          //       accept={allowedFileTypes}
          //       onRemove={this.fileUploader}
          //       onSelect={ (e) => {
          //         const files = e.files;
          //         for (let file of files) {
          //             if (!allowedFileTypes.includes(file.type)) {
          //                 this.toast.show({ severity: 'error', summary: 'Error', detail: `${file.name} is not an allowed file type.`, life: 3000 });
          //                 e.files = e.files.filter(f => f !== file);
          //             }
          //         }
          //       }}
          //       uploadHandler={this.fileUploader}
          //     />
          //   </div>
          // );
        } else {
          const data = field.Value?.map(file => {
            let match = file.path?.match(/\/([^\/]+)$/, "$1");
            if (!match) {
              match = file.path?.match(/\\([^\\]+)$/, "$1");
            }
            const filename = match?.[1];
            return {
              attachmentFileName: filename,
              attachmentFileContent: file.attachment,
            }
          })
          controlArray.push(
            <div>
              <DataTable key={'file_' + field.Id} value={data} id={'table_' + + field.Id} dataKey="id" emptyMessage={null} style={{ width: '100%' }}>
                <Column field="attachmentFileName" header="File Name" />
                <Column body={this.actionTemplate} style={{ textAlign: 'center', width: '6em' }} />
              </DataTable>
            </div>
          )
        }
        break;
      //to add code for OCR. so far it is located in the API
      case 'Invoice':
        this.fileField = field;
        if (editable) {
          controlArray.push(<div>
            {/* @ts-ignore */}
            <FileUpload name="attachment[]" customUpload={true} maxFileSize={5000000} onRemove={this.fileUploader} auto={true} uploadHandler={this.fileUploader} multiple={true} />
          </div>);
        }
        
        controlArray.push(
          <div>
            <iframe width="100%" src={this.attachment["attachmentFileContent"]} height="400"  ></iframe>
          </div>
        )

        this.displayInInvoiceTable(controlArray);
        break;

      case 'Download':
        controlArray.push(
          <div>
            {labelControlArray}
            {this.generateDownloadButton(field)}
          </div>);
        break;

      case 'Image':
        field.Valid = true;
        controlArray.push(
          <div style={{ textAlign: 'center', }}>
            <img src={field.Value?.content} style={{ height: '400', width: '320px' }} alt={field.Value?.content}></img>
          </div>);
        break;
      case 'Button':
        controlArray.push(
          <ButtonComponent key={"ButtonComponent" + field.Id} 
          field={this.props.field} 
          editable={editable} 
          title={title} 
          labelControlArray={labelControlArray} 
          requiredField={requiredField}
          isEng={this.props.isEng} 
          callbackValidate={(errors)=>this.props.callbackValidate(errors)}
          callbackStepIndex={(index)=>this.props.callbackStepIndex(index)}  
          returnIndex={this.props.returnIndex}
            callback={(programContainer) => {this.props.callbackElement(programContainer)}}>
          </ButtonComponent>);
          break;
      case 'PublicSecureButton':
        controlArray.push(
          <PublicSecureButtonComponent key={"PublicSecureButtonComponent" + field.Id}
            field={this.props.field}
            editable={editable}
            title={title}
            labelControlArray={labelControlArray}
            requiredField={requiredField}
            isEng={this.props.isEng}
            callbackStepIndex={(index) => this.props.callbackStepIndex(index)}
            returnIndex={this.props.returnIndex}
            callback={(programContainer) => { this.props.callbackElement(programContainer) }}>
          </PublicSecureButtonComponent>);
        break;    
      case 'RepeatButton':
          controlArray.push(
            <RepeatButtonComponent key={"RepeatButtonComponent" + field.Id} field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
            isEng={this.props.isEng} callbackStepIndex={(index)=>this.props.callbackStepIndex(index)}  returnIndex={this.props.returnIndex}
              callback={(programContainer) => {this.props.callbackElement(programContainer)}}>
            </RepeatButtonComponent>);
            break;
          break;
      case 'GoogleLookUpAddress':
        controlArray.push(
          <GoogleLookUpAddressComponent 
            field={this.props.field} 
            editable={editable} 
            title={title} 
            labelControlArray={labelControlArray} 
            requiredField={requiredField}
            isEng={this.props.isEng}
            callbackElement={(subSection: FormSubSections) => {
              this.props.callbackElement(subSection.parent.parent)}
            }></GoogleLookUpAddressComponent>
        )
        break;
        case "CustomErrorAlerts":
          controlArray.push( <CustomErrorAlertsComponent field={this.props.field}  isEng={this.props.isEng}
         callbackElement={(programContainer ) => {this.props.callbackElement(programContainer)}}></CustomErrorAlertsComponent>);
         break;
      case "DriverLicense":
        controlArray.push(
          <DriverLicenseComponent field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}
         callbackElement={(programContainer ) => {this.props.callbackElement(programContainer)}}></DriverLicenseComponent>
        )
        break;
      case "Feedback":
        controlArray.push(
          <FeedbackComponent programContainer={this.props.field.parent.parent.parent} isEng={this.props.isEng} field={this.props.field}></FeedbackComponent>
        )
        break;
      case "LicensePlate":
        controlArray.push(
          <LicensePlateComponent field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}
         callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}></LicensePlateComponent>
        )
          break;
      case "HealthCard":
        controlArray.push(
          <HealthCardComponent field={this.props.field} editable={editable} title={title} labelControlArray={labelControlArray} requiredField={requiredField}
          isEng={this.props.isEng}
         callbackElement={(programContainer) => {this.props.callbackElement(programContainer)}}></HealthCardComponent>
        )
            break;
      case "InformationAlert":
        controlArray.push(<InformationalAlertComponent  isEng={this.props.isEng} field={field}/>)
        break;
      case "WarningAlert":
        controlArray.push(<WarningAlertComponent isEng={this.props.isEng} Visible={field.Visible} bodyMsg={reactElement} title={this.props.isEng? field.MessageTitle:field.MessageTitleFRA} />);
        break;
      case "ErrorAlert":
        controlArray.push(<ErrorAlertComponent field={field} isEng={this.props.isEng} Visible={field.Visible} bodyMsg={reactElement} title={this.props.isEng? field.MessageTitle:field.MessageTitleFRA} />);
        break;
      case "SuccessAlert":
        controlArray.push(<SuccessAlertComponent field={field} isEng={this.props.isEng} Visible={field.Visible} bodyMsg={reactElement} title={this.props.isEng? field.MessageTitle:field.MessageTitleFRA} />);
        break;
      case 'StarRating':
        // controlArray.push(<StarRating field={field} isEng={this.props.isEng} title={this.props.isEng? field.MessageTitle:field.MessageTitleFRA} callbackElement = {p => this.props.callbackElement(p)} />);
        controlArray.push(<StartRatingAccessibilityComponent field={field} isEng={this.props.isEng} title={this.props.isEng? field.MessageTitle:field.MessageTitleFRA} callbackElement = {p => this.props.callbackElement(p)} />);
        break;
      case 'Accordions':
        controlArray.push(
          <AccordionsComponent
            field={field} 
            contents={this.props.isEng ? field.accordions?.accordions : field.accordionsFRA?.accordions}
            lang={this.props.isEng ? 'en' : 'fr'} 
            expandAll={!!field.accordions?.expandAll}
            callbackStepIndex={(index, returnIndex)=>this.props.callbackStepIndex(index,returnIndex)}
            callBack={p => this.props.callbackElement(p)}/>
        );
        break;
      case 'TransId':
        const root = getRootComponent(field);
        controlArray.push(
          <TransactionIdComponent 
            field={field} 
            transactionId={field.Value} 
            appId={root.CategoryId} 
            lang={this.props.isEng? 'en' : 'fr'} 
            callback={p => this.props.callbackElement(p)}
          />
        )
        break;
      case 'RecaptchaButton':
        controlArray.push(
          <SubmitButtonComponent
            field={field}
            isEng={this.props.isEng}
            callback={(programContainer) => {this.props.callbackElement(programContainer)}}
            callbackValidate={(errors) => this.props.callbackValidate(errors)}
            callbackStepIndex={(index, returnIndex) => this.props.callbackStepIndex(index, returnIndex)}
          />
        )
        break;
      // case 'QRCode': 
      //   //const env = process.env.ENV ?? 'dev';
      //   const root = getRootComponent(this.props.field);
      //   const url = EnvBaseUrl.prod + '/' + root.CategoryId;
      //   controlArray.push(<QRCodeComponent value={url} size={100} />);
      //   break;
      // case 'Callout':
      //   controlArray.push(
      //     <
      //   )
      // default:
      //   let foundArray = ['CheckboxGroup', 'SectionGroup'];
      //   if (foundArray.indexOf(field.Datatype) < 0) {
      //     controlArray.push(
      //       <div key={'fd_' + field.Id} title={'Id:' + field.Id}>
      //         {labelControlArray}
      //         <div>Unknown Datatype: {field.Datatype}</div>
      //       </div>
      //     );
      //   }
    }

    if (field.hintExpansionTitle && editable && field.Visible && field.Datatype != 'CMAQuestion') {
      const bobyMessage = htmlToReactParser.parse(this.props.isEng?  field.callOutBoxBody:field.callOutBoxBodyFRA);
      controlArray.push(
        <div style={field.Datatype != 'RadioButton'? { marginTop: '-3%', maxWidth: '420px' } : null}>
          <HintExpansionComponent
            isEng={true}
            calloutType={field.callOutBoxType}
            Visible={field.Visible}
            bodyMsg={bobyMessage}
            title={this.props.isEng? field.callOutBoxTitle:field.callOutBoxTitleFRA}
            hintExpansionTitle={this.props.isEng? field.hintExpansionTitle:field.hintExpansionTitleFRA}
            field={field}
          ></HintExpansionComponent>
        </div>
      )
    } else if (field.callOutBoxType && editable) {
      const bobyMessage = htmlToReactParser.parse(this.props.isEng?  field.callOutBoxBody:field.callOutBoxBodyFRA);
      const reactElement = htmlToReactParser.parse(bobyMessage);
      const callOutBoxTitle = this.props.isEng? field.callOutBoxTitle:field.callOutBoxTitleFRA;
      //call out box
      switch (field.callOutBoxType) {
        case 'general':
          controlArray.push(
            <GeneralCalloutComponent
              isEng={this.props.isEng}
              bodyMsg={reactElement}
              title={callOutBoxTitle}
            ></GeneralCalloutComponent>)
          break;
        case 'informational':
           controlArray.push(<InformationalAlertComponent  isEng={this.props.isEng} field={field}/>)
          break;
        case 'warning':
          controlArray.push(
            <WarningAlertComponent
              isEng={this.props.isEng}
              bodyMsg={reactElement}
              title={callOutBoxTitle}
              Visible={field.Visible}
            ></WarningAlertComponent>)
          break;
        case 'success':
          controlArray.push(
            <SuccessAlertComponent
              isEng={this.props.isEng}
              bodyMsg={reactElement}
              title={callOutBoxTitle}
              Visible={field.Visible}
              field={field}
            ></SuccessAlertComponent>)
          break;
        case 'error':
          controlArray.push(
            <ErrorAlertComponent
              isEng={this.props.isEng}
              bodyMsg={reactElement}
              title={callOutBoxTitle}
              Visible={field.Visible}
              field={field}
            ></ErrorAlertComponent>)
          break;
      }
    }



    return controlArray;
  }


  actionTemplate(rowData, column) {
    // if(rowData["id"]==null) return null;
    return <div>
      <Button type="button" icon="pi pi-download" className="p-button-success"
        onClick={async () => {
          let a = document.createElement("a"); //Create <a>    
          if (rowData['attachmentFileContent'] != null && rowData['attachmentFileContent'].toString().startsWith("data:")) {
            a.href = rowData['attachmentFileContent'];
            a.download = rowData['attachmentFileName'];
            a.click();
          } else {
            let response = await axios.get(URLUtils.concatUrls("data/program/fileRetrieval/" + rowData["id"]), { withCredentials: true });
            let data = response.data;
            a.href = "data:" + rowData["attachmentFileType"] + ";base64," + data;
            a.download = rowData['attachmentFileName'];
            a.click();
          }
        }
        }></Button>
    </div>;
  }

  fileField: FormSectionElements;
  attachment = {};

  excelUploader = async (files) => {
    this.fileUploaded = true;

    let worksheetNames = [];
    let attachment = [];

    for (const file of files.files) {
      const reader = new FileReader();

      const readFile = () => {
        return new Promise<void>((resolve, reject) => {
          reader.onload = function (e) {
            const binarystr = e.target.result;
            const wb = XLSX.read(binarystr, { type: 'binary', cellDates: true });
            wb.SheetNames.forEach(function (sheetName) {
              worksheetNames.push(sheetName);
              var XL_row_object = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], { header: 1, dateNF: "dd/mm/yyyy" });
              attachment.push(XL_row_object);
            });
            resolve();
          };
          reader.onerror = function (e) {
            reject(e);
          };
        });
      };

      reader.readAsBinaryString(file);
      await readFile();
    }

    this.attachmentContent = attachment;
    this.setState({ attContent: attachment });
    this.worksheetNames = worksheetNames;
  };

  onExcelRemove = () => {
    const root = getRootComponent(this.props.field);
    let activeObject = parseJson(stringifyJson(this.props.field, root.CategoryId), root.CategoryId);

    activeObject.Value = null;

    // this.setState({ activeObject: activeObject }, () => {

    // });
  }

  fileUploader = (e) => {
    // let entity = [];
    this.fileField.Value = [];
    e.files?.forEach(element => {
      var reader = new FileReader();
      reader.onload = () => {
        let attachment = {};
        attachment["attachmentFileName"] = element.name;
        attachment['attachmentFileType'] = element.type;
        attachment['attachmentFileContent'] = reader.result;
        // let foundElement = entity.filter(p => p.attachmentFileName == element.name);
        // if (foundElement == null || foundElement.length == 0) {
        this.fileField.Value.push(attachment)

        // entity.push(this.fileField.LoadBindName, this.attachment);
        // let api = "data/admin/ocr";
        // axios.post(URLUtils.concatUrls(api), this.attachment, { withCredentials: true }).then((result) => {

        //   this.parseResult(result.data);
        // })
      }

      reader.readAsDataURL(element);
    });
    console.log(e);
    //  this.fileField.Value=e.files;
    // e.files = null;
    // this.props.topEntity[this.fileField.LoadBindName] = entity;
  };


  invoiceDetailItems = [];
  parseResult = (result) => {
    //look for item detail table
    let resultArray = result.split(/\r?\n|\r|\n/g);

    let numberIndexArray = [];
    for (let i = 0; i < resultArray.length; i++) {
      if (!Number.isNaN(+resultArray[i].replace('$', ''))) {

        numberIndexArray.push(i)
      }
    }

    let j;
    for (let i = 0; i < numberIndexArray.length; i++) {
      //to detect if the i is consective
      //if(numberIndexArray[i]==numberIndexArray[i+1]-1 && numberIndexArray[i]==numberIndexArray[i+2]-2){
      if (numberIndexArray[i] == numberIndexArray[i + 1] - 1) {
        j = i;
        break;
      }
    }

    let startLineNumer = numberIndexArray[j];
    //assume 3 columns for number


    for (let i = 0; i < numberIndexArray.length; i += 4) {
      let description = resultArray[startLineNumer + i - 1];
      let qty = resultArray[startLineNumer + i];
      let unitPrice = resultArray[startLineNumer + i + 1];
      let amount = resultArray[startLineNumer + i + 2];
      this.invoiceDetailItems.push({
        description: description,
        qty: qty,
        unitPrice: unitPrice,
        amount: amount
      })
    }

  }

  displayInInvoiceTable = (controlArray) => {
    let columns = [];

    if (this.invoiceDetailItems.length > 0) {
      columns.push(<Column field='description' header='Description' ></Column>);
      columns.push(<Column field='qty' header='Qty' ></Column>);
      columns.push(<Column field='unitPrice' header='Unit Price' ></Column>);
      columns.push(<Column field='amount' header='Amount'></Column>);
      controlArray.push(
        <div key='fdTable_div_invoice' style={{ width: '100%' }}>
          <DataTable showGridlines key={'BtnAdd_invoice'} value={this.invoiceDetailItems} id={'table_invoice'}
            dataKey="id" emptyMessage={null} style={{ width: '100%' }}>
            {columns}
          </DataTable>
        </div>)
    }
  }

  displayExcelTable = (field) => {
    const attachments = this.state.attContent;
    //console.log(attachments);

    if (attachments.length > 0) {
      attachments.forEach((ws) => {
        let wsHeader = ws[0]
        ws = this.convertoJson(wsHeader, ws);
        this.populateFormControlsForExcel(wsHeader, field, ws);
      })
    } else {
      return null;
    }
  }

  populateFormControlsForExcel(headers: [], excelField: FormSectionElements, data) {
    const subSection = new FormSubSections();
    subSection.parent = excelField;
    subSection.Sequence = 1;
    subSection.ListOfFormSectionElements = [];

    if (excelField.Datatype !== 'Excel Template') {
      headers.forEach((header, index) => {
        const ele = new FormSectionElements();

        if (data[0][header] instanceof Date) {
          ele.Datatype = 'Date';
        } else {
          ele.Datatype = 'Text';
        }
        ele.ENUTitle = header;
        ele.Editable = 'Y';
        ele.LoadBindName = header;
        ele.Sequence = index;
        ele.parent = subSection;
        subSection.ListOfFormSectionElements.push(ele);
      })

      excelField.subSectionList = [];
      excelField.subSectionList.push(subSection);

    }
    //first time read from excel, second time render from element list
    if (this.fileUploaded) {
      excelField.Value = data;

      this.fileUploaded = false;
    }
  }


  convertoJson = (headers, data) => {
    let rows = [];

    data.forEach((row, rindex) => {
      let rowData = {};
      //ignore headers
      if (rindex != 0) {
        row.forEach((el, index) => {
          rowData[headers[index]] = el;
        })
        rows.push(rowData);
      }
    })

    if (this.props.field.HasSummaryRow == 'Y')
      rows = this.calcTotal(rows)

    //console.log(rows);

    return rows;
  }

  calcTotal(rows) {
    let totals = {};

    if (!rows || rows.length == 0) {
      return null;
    }

    totals = rows.reduce((acc, invoice) => {
      Object.entries(invoice).forEach(([key, value]) => {
        if (typeof value === 'number') {
          if (acc.hasOwnProperty(key)) {
            acc[key] += value;
          } else {
            acc[key] = value;
          }
        }
      });
      return acc;
    }, {});

    const keys = Object.keys(rows[0]);
    if (keys.length > 0) {
      const firstKey = keys[0];
      totals[firstKey] = this.TOTAL_COLUMN_VALUE;
    }

    rows.push(totals);

    return rows
  }

  generateDownloadButton(field) {
    if (!field.Value || !field.Value.content) {
      return null;
    }

    return <div style={{ marginBottom: '5%' }}>
      <p>{field.Value.fileName}</p>
      <Button type="button" icon="pi pi-download" className="p-button-success"
        onClick={async () => {
          let a = document.createElement("a"); //Create <a>    
          if (field.Value && field.Value.content) {
            a.href = field.Value.content;
            a.download = field.Value.fileName;
            a.click();
          }
        }
        }>Download Template</Button>
    </div>;
  }

  ConvertToCSV(objArray, headerList) {
    let array = objArray;
    let str = '';
    let row = '';

    for (let index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = (i + 1) + '';
      for (let index in headerList) {
        let head = headerList[index];

        line += ',' + array[i][head];
      }
      str += line + '\r\n';
    }
    return str;
  }

  downloadToCSV(data, filename, headers) {
    let csvData = this.ConvertToCSV(data, headers);

    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  extractHeadersAndDownloadFile = (field) => {
    let headers = [];
    let data = [];
    if (field) {
      field.subSectionList[0].ListOfFormSectionElements.forEach(column => {
        headers.push(column.ENUTitle);
      })
    }


    return <div style={{ marginBottom: "5%" }}>
      <Button
        onClick={async () => {
          this.downloadToCSV(data, field.ENUTitle, headers);
        }}>Download {field.ENUTitle}</Button>
    </div>
  }

 
}